import React, { useEffect, useState } from 'react';
import { Checkbox } from '@material-ui/core';
import PropTypes from 'prop-types';
import InfoDialog from '../../../../components/InfoDialog';

const LOCAL_STORAGE_KEY = 'doNotShowBondingDateInfoNote';

const BondingDateReminder = ({ proceed }) => {
  const [showPopup] = useState(localStorage.getItem(LOCAL_STORAGE_KEY) !== '1');
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!showPopup) {
      proceed();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = event => {
    localStorage.setItem(LOCAL_STORAGE_KEY, event.target.checked ? '1' : '0');
    setChecked(event.target.checked);
  };

  if (!showPopup) {
    return '';
  }

  return (
    <InfoDialog
      open
      onClose={() => proceed()}
      title="Note"
      content={
        <>
          <p>
            For maximum bracket accuracy, cases should be bonded no later than 30 days from this
            submission date.
          </p>
          <p>
            <Checkbox checked={checked} onChange={handleChange} />
            Please don't show this message again
          </p>
        </>
      }
    />
  );
};

BondingDateReminder.propTypes = {
  proceed: PropTypes.func.isRequired
};

export default BondingDateReminder;
